import {Routes, Route} from 'external/react' 
import AssessmentsPage from './AssessmentsPage'
import Assessment from './Assessment'

export default function AssessmentsRouter() {
  return (
    <Routes>
      <Route path="/" element={<AssessmentsPage />} />
      <Route path="/:assessmentId/*" element={<Assessment />} />
    </Routes>
  )
}
